import useI18n from './useI18n'
import { UnitLabel } from '@/shared/config/config'

export const useReportFormatting = () => {
  const { dateLongFormatterMonthYear, numberFormatter3Decimals } = useI18n()

  const formatReportPeriod = (
    startDate: Date,
    endDate: Date,
    options?: {
      showYearOnly?: boolean
    }
  ): string => {
    if (options?.showYearOnly) {
      const entireCalendarYear =
        startDate.getMonth() === 0 &&
        endDate.getMonth() === 11 &&
        startDate.getFullYear() === endDate.getFullYear()

      if (entireCalendarYear) {
        return startDate.getFullYear().toString()
      }
    } else {
      const sameMonthAndYear =
        startDate.getFullYear() === endDate.getFullYear() &&
        startDate.getMonth() === endDate.getMonth()

      if (sameMonthAndYear) {
        return dateLongFormatterMonthYear(startDate)
      }
    }

    return `${dateLongFormatterMonthYear(startDate)} - ${dateLongFormatterMonthYear(endDate)}`
  }

  const formatActivityLevel = (activityLevel?: number | null): string => {
    return activityLevel ? `${activityLevel} ${UnitLabel.t}` : '-'
  }

  const formatSpecificDirectEmbeddedEmissions = (
    specificDirectEmbeddedEmissions?: number | null
  ): string => {
    return specificDirectEmbeddedEmissions
      ? `${numberFormatter3Decimals(specificDirectEmbeddedEmissions)} ${UnitLabel.tCO2ePerT}`
      : '-'
  }

  const formatSpecificIndirectEmbeddedEmissions = (
    specificIndirectEmbeddedEmissions?: number | null
  ): string => {
    return specificIndirectEmbeddedEmissions
      ? `${numberFormatter3Decimals(specificIndirectEmbeddedEmissions)} ${UnitLabel.tCO2ePerT}`
      : '-'
  }

  return {
    formatReportPeriod,
    formatActivityLevel,
    formatSpecificDirectEmbeddedEmissions,
    formatSpecificIndirectEmbeddedEmissions
  }
}
